<div class="form">
    <h3>NPC Admin</h3>

    @if (isDev) {
        <p class="subtitle">Simulate College Board EPL sign-in (not available off the production admin site).</p>
        <hr />

        @if (authService.eplLoginError$ | async; as error) {
            <div class="alert alert-warning" role="alert">
                <p>We were unable to log you in.</p>
                <p>{{ error }}</p>
            </div>
        }

        <ul class="mock-list">
            @for (scenario of mockScenarios; track scenario.id) {
                <li>
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="simulateEplLogin(scenario.id)"
                        [disabled]="mocking">
                        {{ mocking ? 'Signing in…' : scenario.label }}
                    </button>
                    <p class="mock-description">{{ scenario.description }}</p>
                </li>
            }
        </ul>
    } @else if (authService.eplLoginError$ | async; as error) {
        <div class="alert alert-warning" role="alert">
            <p>We were unable to log you in.</p>
            <p>{{ error }}</p>
            <p>Please contact <a href="mailto:npc_support@rewiretech.com">npc_support&#64;rewiretech.com</a> for assistance</p>
        </div>
        <button mat-stroked-button type="button" class="redirect-action" (click)="retryAfterError()">
            Try again
        </button>
    } @else if (authService.eplLoginInProgress$ | async) {
        <div class="spinner-container">
            <mat-spinner [diameter]="75"></mat-spinner>
            <p>Signing you in…</p>
            <p class="subtitle">Please wait while we finish setting up your session.</p>
        </div>
    } @else {
        <p class="cutover-notice">
            NPC Admin now uses <strong>College Board sign-in</strong>. Email and password login is no longer available.
        </p>

        @if (countdown !== null) {
            <p class="countdown" aria-live="polite">
                Redirecting in <strong>{{ countdown }}</strong> {{ countdown === 1 ? 'second' : 'seconds' }}…
            </p>
        }

        <button
            mat-flat-button
            type="button"
            color="primary"
            class="redirect-action"
            (click)="beginEplRedirect()"
            [disabled]="redirecting"
            [attr.aria-busy]="redirecting">
            @if (redirecting) {
                <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
                Redirecting to College Board…
            } @else {
                Continue to College Board sign-in
            }
        </button>
    }
</div>
